export default __webpack_public_path__ + "static/media/b2.8ad70483.jpg";